import { render, staticRenderFns } from "./requerimientos.vue?vue&type=template&id=3ebc7560&scoped=true&"
import script from "./requerimientos.vue?vue&type=script&lang=js&"
export * from "./requerimientos.vue?vue&type=script&lang=js&"
import style0 from "./requerimientos.vue?vue&type=style&index=0&id=3ebc7560&lang=scss&scoped=true&"
import style1 from "./requerimientos.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebc7560",
  null
  
)

export default component.exports